export default "__VITE_ASSET__9dZNsO8r__"